import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "./logo.png";

const Navbar = () => {
  const [isTestsDropdownOpen, setIsTestsDropdownOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const mode = window.localStorage.getItem('mode');
    const root = document.getElementsByTagName('html')[0];

    if (mode !== undefined && mode === 'dark') {
      setIsDarkMode(true);
      root.classList.add('dark-mode');
    } else {
      setIsDarkMode(false);
      root.classList.remove('dark-mode');
    }
  }, []);

  const toggleTheme = () => {
    const root = document.getElementsByTagName('html')[0];

    if (isDarkMode) {
      window.localStorage.setItem('mode', 'light');
      setIsDarkMode(false);
      root.classList.remove('dark-mode');
    } else {
      window.localStorage.setItem('mode', 'dark');
      setIsDarkMode(true);
      root.classList.add('dark-mode');
    }
    setIsDarkMode(!isDarkMode);
  };

  const toggleTestsDropdown = () => {
    setIsTestsDropdownOpen(!isTestsDropdownOpen);
  };

  const closeDropdown = () => {
    setIsTestsDropdownOpen(false);
  };

  // Encode Cyrillic domain for proper URL handling
  const encodedDomain = encodeURI("https://форматы.рус");

  // Dark mode toggle icons
  const menuSwitch = (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
      />
    </svg>
  );

  const lightSwitch = (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
      />
    </svg>
  );

  return (
    <nav className="shadow-lg">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center space-x-4">
            <a 
              className="flex items-center space-x-2 text-purple-400 font-bold text-xl hover:text-yellow-400 transition-colors" 
              href={encodedDomain}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={logo} alt="logo" className="w-12 h-12" />
              <span className="hidden sm:inline">Форматы</span>
            </a>
          </div>

          {/* Navigation Menu - Right aligned on mobile */}
          <div className="flex items-center space-x-2 sm:space-x-8">
            <Link
              to="/"
              className="px-2 py-2 text-md sm:text-md transition-colors font-bold text-purple-400 hover:text-yellow-500"
            >
              <span className="hidden sm:inline">Тесты Интеллекта</span>
              <span className="sm:hidden">Тесты Интеллекта</span>
            </Link>

            {/* Tests Dropdown */}
            <div className="relative">
              <button
                onClick={toggleTestsDropdown}
                className="px-2 py-2 rounded-md text-md sm:text-md font-medium transition-colors flex items-center text-purple-400 hover:text-yellow-500"
              >
                <span className="hidden sm:inline">Тесты</span>
                <span className="sm:hidden">Тесты</span>
                <svg
                  className={`ml-1 h-4 w-4 transition-transform ${
                    isTestsDropdownOpen ? "rotate-180" : ""
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>

              {/* Dropdown Menu */}
              {isTestsDropdownOpen && (
                <div className="absolute right-0 mt-2 w-64 bg-white rounded-md shadow-lg z-50 border border-gray-200">
                  <div className="py-1">
                    <Link
                      to="/tests"
                      onClick={closeDropdown}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Все тесты
                    </Link>
                    <Link
                      to="/tests/natural-intelligence"
                      onClick={closeDropdown}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Тест по природным интеллектам
                    </Link>
                    <Link
                      to="/tests/intelligence-types"
                      onClick={closeDropdown}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Анкета по типам интеллекта
                    </Link>
                    <Link
                      to="/tests/belbin"
                      onClick={closeDropdown}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Анкета по Белбину
                    </Link>
                    <Link
                      to="/tests/ors"
                      onClick={closeDropdown}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Тест на определение ОРС
                    </Link>
                    <Link
                      to="/tests/subtype"
                      onClick={closeDropdown}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Тест на подтип личности
                    </Link>
                  </div>
                </div>
              )}
            </div>

            {/* Dark Mode Toggle */}
            <label 
              className="form-check form-switch mode-switch order-lg-2 pe-3 ml-auto cursor-pointer p-2 rounded-md text-purple-400 hover:text-yellow-400 transition-colors" 
              onClick={toggleTheme}
            >
              {isDarkMode ? menuSwitch : lightSwitch}
            </label>
          </div>
        </div>
      </div>

      {/* Click outside to close dropdown */}
      {isTestsDropdownOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={closeDropdown}
        ></div>
      )}
    </nav>
  );
};

export default Navbar;